export const colorUserLevel = (level) => {
    let levels = {
        1: 'text-success',
        2: 'text-secondary'
    }
    return levels[level] ?? ""
}
